function thingIt(){

}

thingIt.controllers = {};

thingIt.controller = function(id, controller) {
    thingIt.controllers[id] = controller;
}